import script from "./AssemblePage.vue?vue&type=script&setup=true&lang=js"
export * from "./AssemblePage.vue?vue&type=script&setup=true&lang=js"

import "./AssemblePage.vue?vue&type=style&index=0&id=640f3bf6&scoped=true&lang=css"

import exportComponent from "/home/marco/docker-devs/laundryrepublic/codebase/lr-epos2-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-640f3bf6"]])

export default __exports__